import fetch from "../utils/fetch";

let dataUrl = process.env.REACT_APP_DATA_API_URL

// 获取用户信息
export function getUserInfo(data) {
  return fetch({
    url: "/user/",
    method: "get",
    params: data,
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
  });
}

// 更新用户信息
export function updateUserInfo(data, id) {
  return fetch("/user/" + id + "/", {
    method: "patch",
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
    data,
  });
}

// 获取所有文件列表
export function getAllFileList(data) {
  return fetch({
    url: "/medical_file/search/",
    method: "get",
    params: data,
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
  });
}

// 获取市场文件列表
export function getMarketFileList(data) {
  return fetch({
    url: "/medical_file/market_search/",
    method: "get",
    params: data,
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
  });
}

// 获取所有文件列表-直观复兴
export function getAllFileListZGFX(data) {
  return fetch({
    url: "/medical_file/search_zgfx/",
    method: "get",
    params: data,
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
  });
}
//获取所有标签
export function getAllLableList(data) {
  return fetch({
    url: "/lable_category/",
    method: "get",
    params: data,
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
  });
}
//获取zgfx标签
export function getZgfxLableList(data) {
  return fetch({
    url: "/lable_category/zgfx/",
    method: "get",
    params: data,
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
  });
}

//获取标签-根据标签名
export function getLabelDetail(data) {
  return fetch({
    url: "/lable/",
    method: "get",
    params: data,
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
  });
}
//获取标签id-根据标签名
export function getLabelIdByName(data) {
  return fetch({
    url: "/api/lable/lable_content",
    method: "get",
    params: data,
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
  });
}
//新增标签
export function addLabel(data) {
  return fetch({
    url: "/lable/",
    method: "post",
    data: data,
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
  });
}
//收藏文件
export function collectFile(data) {
  return fetch({
    url: "/user_favorite_basefile_relationship/",
    method: "post",
    data: data,
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
  });
}
//获取收藏关系
export function getCollectInfo(data) {
  return fetch({
    url: "/user_favorite_basefile_relationship/",
    method: "get",
    params: data,
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
  });
}
//取消收藏
export function cancelCollectFile(id) {
  return fetch({
    url: "/user_favorite_basefile_relationship/" + id + "/",
    method: "delete",
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
  });
}
//下载列表
export function exportFavoriteFile() {
  return fetch({
    url: "/flow_export/export_favorite_file_info/",
    method: "post",
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
    responseType: "blob",
  });
}
//给文件添加标签
export function addLabelToFile(data) {
  return fetch({
    url: "/basefile_be_labled_relationship/",
    method: "post",
    data: data,
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
  });
}
//获取文件-标签列表
export function getFileLabelList(data) {
  return fetch({
    url: "/basefile_be_labled_relationship/",
    method: "get",
    params: data,
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
  });
}
//删除文件标签
export function delelteFileLabel(id) {
  return fetch({
    url: "/basefile_be_labled_relationship/" + id + "/",
    method: "delete",
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
  });
}
//查询文件标签（普通用户自己打的标签）、收藏文件
export function getUserFileLabel(data) {
  return fetch({
    url: "/base_file/",
    method: "get",
    params: data,
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
  });
}
//查询文件标签（普通用户自己打的标签）-新接口
export function getUserFileLabelNew(data) {
  return fetch({
    url: "/basefile_be_labled_relationship/",
    method: "get",
    params: data,
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
  });
}
//查询用户收藏文件
export function getCollectList(data) {
  return fetch({
    url: "/medical_file/get_favorite_file_list/",
    method: "get",
    params: data,
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
  });
}
//查询用户收藏文件-无标签
export function getSpecialCollectList(data) {
  return fetch({
    url: "/medical_file/untagged/",
    method: "get",
    params: data,
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
  });
}
//查询用户收藏文件-普通标签
export function getDefaultLabelFileList(data) {
  return fetch({
    url: "/medical_file/get_specific_file_list/",
    method: "get",
    params: data,
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
  });
}

// 获取订阅列表
export function getSubscribeList(data) {
  return fetch({
    url: "/medical_file/search/",
    method: "get",
    params: data,
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
  });
}

// 查询用户订阅标签列表
export function getUserSubscribeLabeList(data) {
  return fetch({
    url: "/user_subsribe_lable_relationship/",
    method: "get",
    params: data,
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
  });
}
// 新增订阅标签
export function addSubscribeLabel(data) {
  return fetch({
    url: "/user_subsribe_lable_relationship/",
    method: "post",
    data: data,
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
  });
}
// 删除订阅标签
export function deleteSubscribeLabel(id) {
  return fetch({
    url: "/user_subsribe_lable_relationship/" + id + "/",
    method: "delete",
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
  });
}
// 新增收藏标签
export function addCollectLabel(data) {
  return fetch({
    url: "/user_favorite_lable_relationship/",
    method: "post",
    data: data,
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
  });
}
// 用户收藏标签列表
export function getUserCollectLabeList(data) {
  return fetch({
    url: "/user_favorite_lable_relationship/",
    method: "get",
    params: data,
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
  });
}
// 用户删除收藏标签
export function deleteCollectLabel(id) {
  return fetch({
    url: "/user_favorite_lable_relationship/" + id + "/",
    method: "delete",
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
  });
}
// 用户删除收藏标签-文件
export function deleteCollectFileLabel(data) {
  return fetch({
    url: "/basefile_be_labled_relationship/remove_lable_from_basefile/",
    method: "get",
    params: data,
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
  });
}
// 用户删除标签-彻底删除
export function deleteLabelId(id) {
  return fetch({
    url: "/lable/" + id + "/",
    method: "delete",
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
  });
}
// 汇总信息表
export function getInfoList(data) {
  return fetch({
    url: "/accumulation_file/",
    method: "get",
    params: data,
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
  });
}
// 汇总信息表
export function getWeChatInfoList(data) {
  return fetch({
    url: "/wechat_file/",
    method: "get",
    params: data,
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
  });
}

// 修改标签
export function editLabel(data) {
  return fetch({
    url: "/api/lable/replace_lable",
    method: "get",
    params: data,
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
  });
}

// 修改标签
export function retriveLables(data) {
  return fetch({
    url: "/api/categories/retrive_lables",
    method: "get",
    params: data,
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
  });
}

// 汇总信息表
export function getCustomFileInfoList(data) {
  return fetch({
    url: "/base_file/",
    method: "get",
    params: data,
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
  });
}

// 其他按钮汇总信息表
export function getOtherList(data) {
  return fetch({
    url: "/accumulation_file/other/",
    method: "get",
    params: data,
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
  });
}
// 获取团队收藏
export function getGroupCollect(data) {
  return fetch({
    url: "/user/get_company_main_user/",
    method: "get",
    params: data,
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
  });
}
// 获取直观复星所有标签
export function getAllZgfxLabel(data) {
  return fetch({
    url: "/lable_category/",
    method: "get",
    params: data,
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
  });
}
// 新增分类标签
export function addCategoryLabel(data) {
  return fetch({
    url: "/api/lable/create_lable_and_category",
    method: "post",
    data: data,
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
  });
}
// 提交分类流程
export function addFlow(data) {
  return fetch({
    url: "/ticket/create_ticket/",
    method: "post",
    data: data,
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
  });
}
// 法规、标准、指导原则、文件类列表
export function getLawList(data) {
  return fetch({
    url: "/zgfx_lables/filter/",
    method: "post",
    data: data,
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
  });
}

// 法规明细-法规
export function getLawDetail(data) {
  return fetch({
    url: "/regulation_file/zgfx/",
    method: "get",
    params: data,
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
  });
}
// 法规明细-标准
export function getStandardList(data) {
  return fetch({
    url: "/standard_file/zgfx/",
    method: "get",
    params: data,
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
  });
}
// 法规明细-指导原则
export function getInstructionList(data) {
  return fetch({
    url: "/instruction_file/zgfx/",
    method: "get",
    params: data,
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
  });
}

// 竞品专区搜索
export function getProductList(data) {
  return fetch({
    url: "/customed_file/search/",
    method: "get",
    params: data,
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
  });
}
// 跟踪汇总搜索搜索
export function getTrackerList(data) {
  return fetch({
    url: "/wechat_file/search/",
    method: "get",
    params: data,
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
  });
}
// 更新法规清单标签
export function editLawDetailLabels(data) {
  return fetch({
    url: "/zgfx_lables/modify_zgfx_lables/",
    method: "post",
    data: data,
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
  });
}

// 图谱信息
export function getRelationship(data) {
  return fetch({
    url: "/internal_relationship/retrive_relationship/",
    method: "post",
    data: data,
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
  });
}


// 文件类型字典值
export function fileTypes(data) {
  return fetch({
    url: "/file_category/",
    method: "get",
    data: data,
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
  });
}

// 邮件推送配置-详情
export function emailPushSettingDetail(data) {
  return fetch({
    url: "/user_receive_push_category_relationship/get/",
    method: "get",
    data: data,
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
  });
}
// 邮件推送配置-保存
export function saveEmailPushSetting(data) {
  return fetch({
    url: "/user_receive_push_category_relationship/update_relation/",
    method: "put",
    data: data,
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
  });
}

// 获取所有文件状态
export function getFileStatusList(data) {
  return fetch({
    url: "/medical_file/fileStatus/",
    method: "get",
    params: data,
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
  });
}
// 综合搜索
export function mixsearch(data) {
  return fetch({
    url: "/medical_file/mixsearch/",
    method: "get",
    params: data,
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
  });
}
// 创新与优先
export function getInnovateList(data) {
  return fetch({
    url: dataUrl + "/api/innovationAndPrioritization/selectInnovationAndPrioritization",
    method: "get",
    params: data,
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
  });
}
// 医疗器械
export function getMedicalEquipmentList(data) {
  return fetch({
    url: dataUrl + "/api/medicalDeviceCategory/SelectInfo",
    method: "get",
    params: data,
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
  });
}
// 医疗器械 - 产品类别列表数据
export function getTypeOptions(data) {
  return fetch({
    url: dataUrl + "/api/medicalDeviceCategory/GetCascaderOptions",
    method: "get",
    params: data,
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
  });
}
// 获取标准物质
export function getStandardSubstanceList(data) {
  return fetch({
    url: dataUrl + "/api/standardMaterials/SelectInfo",
    method: "get",
    params: data,
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
  });
}
// 获取评审答疑汇总
export function getReviewSummaryList(data) {
  return fetch({
    url: dataUrl + "/api/answeringQuestion/SelectInfo",
    method: "get",
    params: data,
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
  });
}
// 获取评审答疑汇总区域列表
export function getReviewSummaryRegionList(data) {
  return fetch({
    url: dataUrl + "/api/answeringQuestion/GetArea",
    method: "get",
    params: data,
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
  });
}

// 上传文件
export function uploadFile(data) {
  return fetch({
    url: "/api/categories/upload_other_file",
    method: "post",
    data: data,
    headers: {
      Authorization: "Bearer " + localStorage.access,
      'Content-Type': 'multipart/form-data',
    },
  });
}

// 修改用户信息
export function editUserInfo(data) {
  return fetch({
    url: "/api/users/update_user_info",
    method: "post",
    data: data,
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
  });
}